import { DisabledPrompt, useRoute, Branding } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import BaseToggleView from "components/shared/views/BaseToggleView";
import UIAmountInput from "components/ui/UIAmountInput";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import React from "react";

import "./styles.css";
/**
 * @function SpendAlertsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SpendAlertsPage
 */

export default function SpendAlertsPage(props) {
  const navigate = useRoute();

  return (
    <MainContentContainer className="spend-alerts-page" header={
      <MainContentHeader text="Spend Alerts" />
    }>
      <FormContainer>
        <FormRow className="text-row spend-limits-row">
          <div className="bottom-border">
            <p className="main-text">Spend Limits</p>
            <p className="sub-text">Deny a purchase if the amount exceeds the limits below.</p>
          </div>
        </FormRow>
        <FormRow>
          <BaseToggleView
            mainText="Per Transaction"
            subText="Alert me when a transaction exceeds the transaction spend limit."
            checked={true}
            toggleBlock={
              <FormRow>
              <UIAmountInput value="100.00" />
            </FormRow>
            }

          />
        </FormRow>
       
        <Branding id="monthly_spendlimit_chw23" value="true">
          <FormRow className="per-month">
            <BaseToggleView
              mainText="Per Month"
              subText={
                <p>
                  <span className="sub-text">Alert transactions exceeding the monthly spend limit.</span>
                  <br />
                  <span className="sub-text">Current Spend: $0.00</span>
                  <br />
                  <span className="sub-text">(Excludes recurring transactions)</span>
                </p>
                
              }
              checked={true}
              toggleBlock ={
                <FormRow>
                  <UIAmountInput value="1,500.00" />
                </FormRow>
              }
            />
          </FormRow>
        </Branding>
        
        <FormButtonContainer>
          <DisabledPrompt>
            <UIPrimaryButton text="Apply" />
          </DisabledPrompt>
          <UICancelButton text="Cancel" onClick={ evt => navigate(-1) } />
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  );
}